import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ScrollyArticle } from '../components/ScrollyPage/ScrollyArticle';

const StoryBostader = lazy(
    () => import('../components/ScrollyPage/StoryBostader')
);

export const Route = createFileRoute('/om/bostader')({
    component: Index,
});

function Index() {
    return (
        <ScrollyArticle>
            <Suspense fallback={null}>
                <StoryBostader />
            </Suspense>
        </ScrollyArticle>
    );
}
